import {get} from '../utils'
import {includeQuery} from './utils';
import {getActiveChannel, getActiveClient, getStoredChannel} from "../authentication/utils";
import localization from '../../../config/localization';

export default host => (id, include = includeQuery) =>
  get(`${host}${(getStoredChannel() && getStoredChannel().visibility === "public") ? "/public": "/v2"}/clients/${getActiveClient()}/${getActiveChannel() ? `channels/${getActiveChannel()}/` : ""}contentCreators/${id}?${include}${getActiveChannel() ? `&cLang=${localization.getLanguage()}` : ""}`)
    .then(response => response.json())
    .then(json => json.data)
